// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"18":"24d59d48","112":"58b6dea3","648":"a832e327"}[chunkId] + ".js";
};